export default __webpack_public_path__ + "static/media/spot-google-voice.4f5207a7.jpg";